<rid-drop-zone class="block cursor-pointer rounded-md border-4 border-dashed border-white bg-white/30" (click)="cleared.emit()">
  <div class="grid place-items-center">
    <rid-spacer class="stack-cell">
      <rid-klank-card [klank]="longestOption()" />
    </rid-spacer>
    <div class="stack-cell">
      @if (value(); as v) {
        <rid-klank-card [klank]="v" animate.enter="anim-pop-in" />
      }
    </div>
  </div>
</rid-drop-zone>
